import APP_CONST from '@/constants/AppConst'
import APP_UTILITIES from '@/utilities/commonFunctions'

export const scholarInformation = {
  getScholar: () => {
    const date: any = new Date()
    const key = new Date().getTime() + '_' + Math.ceil(Math.random() * 99999)
    const states: any = APP_UTILITIES.getStatesShortFinalList(APP_CONST.COUNTRY_ID)
    return [
      {
        group: 'scholarDetails',
        type: 'scholarName',

        name: 'scholarName',
        title: 'Name',
        elmType: 'grid',
        dropIndex: 0,
        label: 'Child Name',
        columns: [
          {
            span: 12,
            list: [
              {
                type: 'input',

                name: 'scholar_firstname',
                title: 'First Name',
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'First Name',
                  disabled: false,
                  maxLength: 50
                },
                key: key + '_scholar_firstname',
                model:
                  'scholar_firstname' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  { type: 'string', message: 'First Name Invaild format' },
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    pattern: "/^[a-zA-Z '-]+$/",
                    message:
                      'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                  },
                  {
                    min: 0,
                    max: 50,
                    message: 'Firstname must be 0 to 50 charactors',
                    trigger: 'blur'
                  }
                ],
                isDrag: false,
                isEditable: false
              }
            ]
          },
          {
            span: 12,
            list: [
              {
                type: 'input',

                name: 'scholar_lastname',
                title: 'Last Name',
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Last Name',
                  disabled: false,
                  maxLength: 50
                },
                key: key + '_scholar_lastname',
                model:
                  'scholar_lastname' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  { type: 'string', message: 'Last Name Invaild format' },
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    pattern: "/^[a-zA-Z '-]+$/",
                    message:
                      'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)'
                  },
                  {
                    min: 0,
                    max: 50,
                    message: 'Lastname must be 0 to 50 charactors',
                    trigger: 'blur'
                  }
                ],
                isDrag: false,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_scholarName',
        model: 'scholarName' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'scholarDetails',
        type: 'input',
        name: 'scholar_nickname',
        title: 'Nickname',
        dropIndex: 0,
        elmType: 'single',
        label: 'Child Nickname',
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Nickname',
          disabled: false,
          maxLength: 50
        },
        key: key + '_scholar_nickname',
        model:
          'scholar_nickname' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { type: 'string', message: 'Nickname Invaild format' },
          {
            required: true,
            message: 'This field is required. (Es necesario llenar este espacio.)'
          },
          { pattern: "/^[a-zA-Z '-]+$/", message: 'Nickname contains invalid characters' },
          { min: 0, max: 50, message: 'Nickname must be 0 to 50 charactors', trigger: 'blur' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'scholaraddressField',
        name: 'scholarbirthdateField',
        dropIndex: 0,
        title: 'Birth Date / Age',
        elmType: 'addressGrid',
        label: 'Child Birth Date',
        columns: [
          {
            span: 24,
            list: [
              {
                group: 'scholarDetails',
                type: 'input',
                name: 'scholar_birthdate',
                title: 'Birth Date',
                dropIndex: 1,
                elmType: 'single',
                label: 'Child Birth Date',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'MM-DD-YYYY',
                  disabled: false,
                  maxLength: 14
                },
                key: key + '_scholar_birthdate',
                model:
                  'scholar_birthdate' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message:
                      'Be sure to enter MM-DD-YYYY. (Asegúrate de escribir la fecha de nacimiento (mes, día, año) MM-DD-AAAA)'
                  }
                ],
                isDrag: true,
                isEditable: false
              },
              {
                group: 'scholarDetails',
                type: 'input',
                name: 'scholar_age',
                title: 'Age',
                dropIndex: 1,
                elmType: 'single',
                label: 'Child Age',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '--',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Age',
                  disabled: true,
                  maxLength: 3
                },
                key: key + '_scholar_age',
                model:
                  'scholar_age' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [{ required: false, message: '' }],
                isDrag: true,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_scholarbirthdateField',
        model:
          'scholarbirthdateField' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false,
        isHide: false
      },
      {
        group: 'scholarDetails',
        type: 'dropdown',
        name: 'scholar_gender',
        title: 'Gender',
        dropIndex: 0,
        label: 'Child Gender',
        elmType: 'custom',
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: 'Gender',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Female'
            },
            {
              value: 'Male'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_gender',
        model:
          'scholar_gender' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'dropdown',
        name: 'scholar_race',
        title: 'Race / Ethnicity',
        label: 'Child Race / Ethnicity',
        elmType: 'custom',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: 'Select',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Caucasian/White'
            },
            {
              value: 'African American/Black'
            },
            {
              value: 'Hispanic/Latino'
            },
            {
              value: 'Native Hawaiian'
            },
            {
              value: 'Pacific Islander'
            },
            {
              value: 'American Indian or Alaskan Native'
            },
            {
              value: 'Asian'
            },
            {
              value: 'Other'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_race',
        model: 'scholar_race' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'input',

        name: 'scholar_email',
        title: 'Email',
        elmType: 'single',
        label: 'Child Email',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Email',
          disabled: false,
          maxLength: 254
        },
        key: key + '_scholar_email',
        model:
          'scholar_email' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          {
            required: true,
            message:
              'Enter a valid email address. (Escribe una dirección válida de correo electrónico, (email).)'
          }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'phoneNumberType',
        name: 'scholarPhoneNumberType',
        title: 'Phone Number',
        elmType: 'grid',
        label: 'Child Phone Number',
        dropIndex: 0,
        columns: [
          {
            span: 12,
            list: [
              {
                type: 'input',
                name: 'scholar_phone',
                title: 'Phone',
                elmType: 'single',
                label: 'Phone Number',
                dropIndex: 0,
                options: {
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Enter Number',
                  disabled: false,
                  maxLength: 14
                },
                key: key + '_scholar_phonenumber',
                model:
                  'scholar_phonenumber' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  },
                  {
                    min: 14,
                    max: 14,
                    message: 'Phone number must be of 10 digits',
                    trigger: 'blur'
                  }
                ],
                isDrag: true,
                isEditable: false
              }
            ]
          },
          {
            span: 12,
            list: [
              {
                type: 'select',
                name: 'scholar_phonetype',
                title: 'Type',
                elmType: 'single',
                dropdownStatus: false,
                options: {
                  defaultValue: 'Select',
                  multiple: false,
                  disabled: false,
                  clearable: false,
                  placeholder: '',
                  required: false,
                  showLabel: false,
                  width: '',
                  options: [
                    {
                      value: 'Cell'
                    },
                    {
                      value: 'Work'
                    },
                    {
                      value: 'Home'
                    }
                  ],
                  remote: false,
                  filterable: false,
                  remoteOptions: [],
                  props: {
                    value: 'value',
                    label: 'label'
                  },
                  remoteFunc: ''
                },
                key: key + '_scholar_phoneNumber_type',
                model:
                  'scholar_phoneNumber_type' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [],
                isDrag: true,
                isEditable: false
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_scholarPhoneNumberType',
        model:
          'scholarPhoneNumberType' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'scholarDetails',
        type: 'scholaraddressField',
        name: 'scholaraddressField',
        dropIndex: 0,
        title: 'Address',
        elmType: 'addressGrid',
        label: 'Child Address',
        columns: [
          {
            span: 24,
            list: [
              {
                type: 'input',
                name: 'scholar_address1',
                title: 'Address Line 1',
                elmType: 'single',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Address Line 1',
                  disabled: false,
                  maxLength: 150
                },
                key: key + '_scholar_address1',
                model:
                  'scholar_address1' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  }
                ],
                isDrag: false,
                isEditable: false
              },
              {
                type: 'input',
                name: 'scholar_address2',
                title: 'Address Line 2',
                elmType: 'single',
                options: {
                  isHide: false,
                  width: '100%',
                  defaultValue: '',
                  required: false,
                  dataType: 'string',
                  pattern: '',
                  placeholder: 'Address Line 2',
                  disabled: false,
                  maxLength: 150
                },
                key: key + '_scholar_address2',
                model:
                  'scholar_address2' +
                  '_' +
                  new Date().getTime() +
                  '_' +
                  Math.ceil(Math.random() * 99999),
                rules: [
                  {
                    required: true,
                    message: 'This field is required. (Es necesario llenar este espacio.)'
                  }
                ],
                isDrag: false,
                isEditable: false
              },
              {
                elmType: 'grid',
                columns: [
                  {
                    span: 8,
                    list: [
                      {
                        type: 'input',
                        name: 'scholar_city',
                        title: 'City',
                        elmType: 'single',
                        options: {
                          isHide: false,
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'City',
                          disabled: false
                        },
                        key: key + '_scholar_city',
                        model:
                          'scholar_city' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [
                          {
                            required: true,
                            message: 'This field is required. (Es necesario llenar este espacio.)'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 8,
                    list: [
                      {
                        type: 'select',

                        name: 'scholar_state',
                        title: 'State',
                        elmType: 'single',
                        dropdownStatus: false,
                        options: {
                          isHide: false,
                          defaultValue: 'State',
                          multiple: false,
                          disabled: false,
                          clearable: false,
                          placeholder: '',
                          required: false,
                          showLabel: false,
                          width: '',
                          options: (function () {
                            const arr = []
                            for (const state of states) {
                              arr.push({ value: state })
                            }
                            return arr
                          })(),
                          remote: false,
                          filterable: false,
                          remoteOptions: [],
                          props: {
                            value: 'value',
                            label: 'label'
                          },
                          remoteFunc: ''
                        },
                        key: key + '_scholar_state',
                        model:
                          'scholar_state' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [
                          {
                            required: true,
                            message: 'This field is required. (Es necesario llenar este espacio.)'
                          }
                        ],
                        isDrag: true,
                        isEditable: false
                      }
                    ]
                  },
                  {
                    span: 8,
                    list: [
                      {
                        type: 'input',
                        name: 'scholar_zipcode',
                        title: 'Postal Code',
                        elmType: 'single',
                        options: {
                          isHide: false,
                          width: '100%',
                          defaultValue: '',
                          required: false,
                          dataType: 'string',
                          pattern: '',
                          placeholder: 'ZIP Code',
                          disabled: false,
                          maxLength: 5
                        },
                        key: key + '_scholar_zipcode',
                        model:
                          'scholar_zipcode' +
                          '_' +
                          new Date().getTime() +
                          '_' +
                          Math.ceil(Math.random() * 99999),
                        rules: [
                          {
                            required: true,
                            message: 'Be sure to enter all 5 digits(Escribe los 5 números.)'
                          }
                        ],
                        isDrag: false,
                        isEditable: false
                      }
                    ]
                  }
                ],
                options: {
                  gutter: 0,
                  justify: 'start',
                  align: 'top'
                }
              }
            ]
          }
        ],
        options: {
          gutter: 0,
          justify: 'start',
          align: 'top'
        },
        key: key + '_scholaraddressField',
        model:
          'scholaraddressField' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [],
        isDrag: true,
        isEditable: false,
        required: false
      },
      {
        group: 'scholarDetails',
        type: 'input',
        name: 'scholar_schoolname',
        title: 'School Name',
        elmType: 'single',
        label: 'School Name',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'School Name',
          disabled: false,
          maxLength: 50
        },
        key: key + '_scholar_schoolName',
        model:
          'scholar_schoolName' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'input',
        name: 'scholar_studentid',
        title: 'School Student ID',
        elmType: 'single',
        label: 'School Student ID',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'School Student ID',
          disabled: false,
          maxLength: 20
        },
        key: key + '_scholar_studentid',
        model:
          'scholar_studentid' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'input',
        name: 'scholar_reducedmeal',
        title: 'Free or Reduced Price Meals',
        elmType: 'single',
        label: 'Free or Reduced Price Meals',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Free or Reduced Price Meals',
          disabled: false,
          maxLength: 10
        },
        key: key + '_scholar_free_reduced_price_meals',
        model:
          'scholar_free_reduced_price_meals' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'dropdown',
        name: 'scholar_language',
        title: 'Language at Home',
        label: 'Child Language at Home',
        elmType: 'custom',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Spanish'
            },
            {
              value: 'Chinese (Mandarin)'
            },
            {
              value: 'Chinese (Cantonese)'
            },
            {
              value: 'Tagalog'
            },
            {
              value: 'Vietnamese'
            },
            {
              value: 'Arabic'
            },
            {
              value: 'French & French Creole'
            },
            {
              value: 'Korean'
            },
            {
              value: 'Russian'
            },
            {
              value: 'German'
            },
            {
              value: 'Haitian Creole'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_language',
        model:
          'scholar_language' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'dropdown',
        name: 'scholar_grade',
        title: 'Grade',
        elmType: 'custom',
        label: 'Grade',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Pre-K'
            },
            {
              value: 'K'
            },
            {
              value: '1'
            },
            {
              value: '2'
            },
            {
              value: '3'
            },
            {
              value: '4'
            },
            {
              value: '5'
            },
            {
              value: '6'
            },
            {
              value: '7'
            },
            {
              value: '8'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_grade',
        model:
          'scholar_grade' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'dropdown',
        name: 'scholar_tshirt',
        title: 'T-shirt Size',
        elmType: 'custom',
        dropIndex: 0,
        label: 'T-shirt Size',
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'X-Small'
            },
            {
              value: 'Small'
            },
            {
              value: 'Medium'
            },
            {
              value: 'Large'
            },
            {
              value: 'X-Large'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_tshirt',
        model:
          'scholar_tshirt' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarMedicalDetails',
        type: 'input',
        name: 'scholar_allergies',
        title: 'Allergies',
        elmType: 'single',
        label: 'Allergies',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Allergies',
          disabled: false,
          maxLength: 150
        },
        key: key + '_scholar_allergies',
        model:
          'scholar_allergies' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarMedicalDetails',
        type: 'select',
        name: 'scholar_epipen',
        title: 'EPI Pen',
        elmType: 'single',
        label: 'EPI Pen',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Yes'
            },
            {
              value: 'No'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_epipen',
        model:
          'scholar_epipen' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarMedicalDetails',
        type: 'select',
        name: 'scholar_asthmainhaler',
        title: 'Asthma Inhaler',
        elmType: 'single',
        label: 'Asthma Inhaler',
        dropdownStatus: false,
        dropIndex: 0,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: '',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Yes'
            },
            {
              value: 'No'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_asthmainhaler',
        model:
          'scholar_asthmainhaler' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarMedicalDetails',
        type: 'input',
        name: 'scholar_medication',
        title: 'Medications',
        elmType: 'single',
        label: 'Medications',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Medication',
          disabled: false,
          maxLength: 150
        },
        key: key + '_scholar_medication',
        model:
          'scholar_medication' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarMedicalDetails',
        type: 'input',
        name: 'scholar_insuranceprovider',
        title: 'Insurance Provider',
        elmType: 'single',
        label: 'Insurance Provider',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Insurance Provider',
          disabled: false,
          maxLength: 50
        },
        key: key + '_scholar_insurance_provider',
        model:
          'scholar_insurance_provider' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarLearningDetails',
        type: 'select',
        name: 'scholar_iep',
        title: 'IEP',
        elmType: 'single',
        label: 'IEP',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: 'Select',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Yes'
            },
            {
              value: 'No'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_iep',
        model: 'scholar_iep' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarLearningDetails',
        type: 'select',
        name: 'scholar_ell',
        title: 'ELL/LEP',
        elmType: 'single',
        label: 'ELL/LEP',
        dropIndex: 0,
        dropdownStatus: false,
        options: {
          defaultValue: 'Select',
          multiple: false,
          disabled: false,
          clearable: false,
          placeholder: 'Select',
          required: false,
          showLabel: false,
          width: '',
          options: [
            {
              value: 'Yes'
            },
            {
              value: 'No'
            }
          ],
          remote: false,
          filterable: false,
          remoteOptions: [],
          props: {
            value: 'value',
            label: 'label'
          },
          remoteFunc: ''
        },
        key: key + '_scholar_llp',
        model: 'scholar_llp' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarLearningDetails',
        type: 'input',
        name: 'scholar_specialeducation',
        title: 'Special Education Status',
        elmType: 'single',
        label: 'Special Education Status',
        dropIndex: 0,
        options: {
          width: '100%',
          defaultValue: '',
          required: false,
          dataType: 'string',
          pattern: '',
          placeholder: 'Special Education Status',
          disabled: false,
          maxLength: 50
        },
        key: key + '_scholar_specialeducation',
        model:
          'scholar_specialeducation' +
          '_' +
          new Date().getTime() +
          '_' +
          Math.ceil(Math.random() * 99999),
        rules: [
          { required: true, message: 'This field is required. (Es necesario llenar este espacio.)' }
        ],
        isDrag: true,
        isEditable: false
      },
      {
        group: 'scholarDetails',
        type: 'subSection',
        name: 'scholar_customField',
        title: 'Custom Child Field',
        elmType: 'single',
        label: 'Custom Child Field',
        isOpen: false,
        data: [
          {
            group: 'customFieldDetails',
            type: 'singleChoice',
            name: 'singleChoice',
            title: 'Type Your Question',
            dropIndex: 0,
            elmType: 'custom',
            label: 'Type Your Question',
            leftSideTitle: 'Single Choice',
            options: {
              inline: false,
              defaultValue: '',
              showLabel: false,
              options: [
                {
                  value: 'Option 1',
                  label: 'Option 1'
                },
                {
                  value: 'Option 2',
                  label: 'Option 2'
                },
                {
                  value: 'Option 3',
                  label: 'Option 3'
                }
              ],
              required: false,
              width: '',
              remote: false,
              remoteOptions: [],
              props: {
                value: 'value',
                label: 'label'
              },
              remoteFunc: '',
              disabled: false
            },
            key: key + '_singleChoice',
            model:
              'singleChoice' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
            rules: [
              {
                required: true,
                message: 'This field is required. (Es necesario llenar este espacio.)'
              }
            ],
            isDrag: true,
            isEditable: false
          },
          {
            group: 'customFieldDetails',
            type: 'multipleChoice',
            name: 'multipleChoice',
            title: 'Type Your Question',
            dropIndex: 0,
            elmType: 'custom',
            label: 'Type Your Question',
            leftSideTitle: 'Multiple Choice',
            options: {
              inline: false,
              defaultValue: [],
              showLabel: false,
              options: [
                {
                  value: 'Option 1'
                },
                {
                  value: 'Option 2'
                },
                {
                  value: 'Option 3'
                }
              ],
              required: false,
              width: '',
              remote: false,
              remoteOptions: [],
              props: {
                value: 'value',
                label: 'label'
              },
              remoteFunc: '',
              disabled: false
            },
            key: key + '_multipleChoice',
            model:
              'multipleChoice' +
              '_' +
              new Date().getTime() +
              '_' +
              Math.ceil(Math.random() * 99999),
            rules: [
              {
                required: true,
                message: 'This field is required. (Es necesario llenar este espacio.)'
              }
            ],
            isDrag: true,
            isEditable: false
          },
          {
            group: 'customFieldDetails',
            type: 'textAreaQuestion',
            name: 'textAreaQuestion',
            title: 'Type Your Question',
            dropIndex: 0,
            elmType: 'custom',
            label: 'Type Your Question',
            leftSideTitle: 'Short Answer',
            options: {
              width: '100%',
              defaultValue: '',
              required: false,
              dataType: 'string',
              pattern: '',
              placeholder: '',
              disabled: false
            },
            key: key + '_textAreaQuestion',
            model:
              'textAreaQuestion' +
              '_' +
              new Date().getTime() +
              '_' +
              Math.ceil(Math.random() * 99999),
            rules: [
              {
                required: true,
                message: 'This field is required. (Es necesario llenar este espacio.)'
              }
            ],
            isDrag: true,
            isEditable: false
          },
          {
            group: 'customFieldDetails',
            type: 'textAreaLongQuestion',
            name: 'textAreaLongQuestion',
            title: 'Type your question',
            dropIndex: 0,
            elmType: 'custom',
            label: 'Type your question',
            leftSideTitle: 'Long Answer',
            options: {
              width: '100%',
              defaultValue: '',
              required: false,
              dataType: 'string',
              pattern: '',
              placeholder: 'Type placeholder copy',
              disabled: false
            },
            key: key + '_textAreaLongQuestion',
            model:
              'textAreaLongQuestion' +
              '_' +
              new Date().getTime() +
              '_' +
              Math.ceil(Math.random() * 99999),
            rules: [
              {
                required: true,
                message: 'This field is required. (Es necesario llenar este espacio.)'
              }
            ],
            isDrag: true,
            isEditable: false
          },
          {
            group: 'customFieldDetails',
            type: 'dropdown',
            name: 'dropdown',
            title: 'Type your question here',
            dropIndex: 0,
            elmType: 'custom',
            label: 'Type your question here',
            leftSideTitle: 'Dropdown',
            options: {
              inline: false,
              defaultValue: 'Select',
              showLabel: false,
              options: [
                {
                  value: 'Option 1'
                },
                {
                  value: 'Option 2'
                },
                {
                  value: 'Option 3'
                }
              ],
              required: false,
              width: '',
              remote: false,
              remoteOptions: [],
              props: {
                value: 'value',
                label: 'label'
              },
              remoteFunc: '',
              disabled: false
            },
            key: key + '_dropdown',
            model: 'dropdown' + '_' + new Date().getTime() + '_' + Math.ceil(Math.random() * 99999),
            rules: [
              {
                required: true,
                message: 'This field is required. (Es necesario llenar este espacio.)'
              }
            ],
            isDrag: true,
            isEditable: false,
            dropdownStatus: false
          }
        ]
      }
    ]
  }
}
